import { render, staticRenderFns } from "./iframeLink.vue?vue&type=template&id=d4de1280"
import script from "./iframeLink.vue?vue&type=script&lang=js"
export * from "./iframeLink.vue?vue&type=script&lang=js"
import style0 from "./iframeLink.vue?vue&type=style&index=0&id=d4de1280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports